import { FilterState } from '../../../../containers/applicant_tracking/Analytics/Filters';
import { PipelineOverview } from '../../../../entities/applicant_tracking/analytics/PipelineOverview';
import { ApiService } from '../../../ApiService';
import { mapToParams } from '../mapToParams';

export class PipelineOverviewService {
  public static show(
    filterState?: FilterState,
    signal?: AbortSignal,
  ): Promise<PipelineOverview> {
    return ApiService.get(
      '/api/v1/applicant_tracking/analytics/pipeline_overview',
      mapToParams(filterState),
      { signal },
    );
  }
}
